










import { Vue, Component } from 'vue-property-decorator';

@Component({
    components: {}
})
export default class RgTemplateSettings extends Vue {
    activeType: string = 'announcement';

    created() {
        if (this.$route.name === 'rg_template_question') {
            this.activeType = 'question';
        }
    }

    activeTypeChange(val) {
        this.$router
            .push({
                name: `rg_template_${val}`,
                query: {
                    ...this.$route.query
                }
            })
            .catch(e => e);
    }
}
